import { useEffect, useRef, useState } from "react";
import { Routes, Route } from "react-router-dom";
import "@/App.css";
import { initScroll, destroyScroll } from "@/lib/scroll";

import TopoCanvas from "@/components/site/TopoCanvas";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Process from "@/components/site/Process";
import HandoffDemo from "@/components/site/HandoffDemo";
import Pricing from "@/components/site/Pricing";
import Differentiator from "@/components/site/Differentiator";
import FAQ from "@/components/site/FAQ";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import ReconFlow from "@/components/site/ReconFlow";
import GalleriesPage from "@/galleries";

const RECON_AUTO_DISMISSED_KEY = "reconAutoDismissed";

function Site() {
    const [reconOpen, setReconOpen] = useState(false);
    const [hikerVisible, setHikerVisible] = useState(false);
    const [reconAutoOpen, setReconAutoOpen] = useState(false);
    const reconOpenRef = useRef(false);

    useEffect(() => {
          reconOpenRef.current = reconOpen;
    }, [reconOpen]);

    // Single page-mount timer origin driving both entrances (30s hiker,
    // 45s recon panel) — one setTimeout each, both anchored to the same
    // mount instant, offset per spec so they don't compete for attention.
    useEffect(() => {
          const hikerTimer = setTimeout(() => setHikerVisible(true), 30000);
          let quizTimer;
          if (sessionStorage.getItem(RECON_AUTO_DISMISSED_KEY) !== "1") {
                quizTimer = setTimeout(() => {
                      // Don't stack the auto panel on top of a manually-opened modal.
                      if (!reconOpenRef.current) setReconAutoOpen(true);
                }, 45000);
          }
          return () => {
                clearTimeout(hikerTimer);
                if (quizTimer) clearTimeout(quizTimer);
          };
    }, []);

    const closeReconAuto = () => {
          setReconAutoOpen(false);
          sessionStorage.setItem(RECON_AUTO_DISMISSED_KEY, "1");
    };

  return (
        <div className="App grain">
          <TopoCanvas variant="paper" />
          <Nav onOpenRecon={() => setReconOpen(true)} />
          <main className="relative z-10">
            <Hero />
            <Marquee />
            <About hikerVisible={hikerVisible} />
            <Process hikerVisible={hikerVisible} />
            <HandoffDemo />
            <Pricing />
            <Differentiator />
            <FAQ />
            <FinalCTA />
    </main>
        <Footer />
        <ReconFlow open={reconOpen} onClose={() => setReconOpen(false)} />
        <ReconFlow open={reconAutoOpen} onClose={closeReconAuto} variant="drawer" />
    </div>
    );
}

function App() {
  useEffect(() => {
    initScroll();
    return () => destroyScroll();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Site />} />
      <Route path="/galleries" element={<GalleriesPage />} />
    </Routes>
  );
}

export default App;
